// constants.js

export const MEDIA_TYPES = {
  IMAGE: "image",
  VIDEO: "video"
}

export const USER_STATUS = {
  ONLINE: "Online"}
